import {
  FETCH_PROFITLOSS_REQUEST,
  FETCH_PROFITLOSS_SUCCESS,
  FETCH_PROFITLOSS_FAILURE,
} from "./profitlossActionTypes";

// FETCH Profit Loss
export const fetchProfitLossRequest = () => ({
  type: FETCH_PROFITLOSS_REQUEST,
});

export const fetchProfitLossSuccess = (data, dataType) => ({
  type: FETCH_PROFITLOSS_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchProfitLossFailure = (error) => ({
  type: FETCH_PROFITLOSS_FAILURE,
  payload: error,
});